import { render, staticRenderFns } from "./detailsCompliance.vue?vue&type=template&id=33e50baa&scoped=true"
import script from "./detailsCompliance.vue?vue&type=script&lang=js"
export * from "./detailsCompliance.vue?vue&type=script&lang=js"
import style0 from "./detailsCompliance.vue?vue&type=style&index=0&id=33e50baa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e50baa",
  null
  
)

export default component.exports